import { Injectable } from "@angular/core";
import { Adapter } from "@core/adapter";
import { ArticleBlock } from '@modules/knowledge/models/article/article-block';
import { ArticleMedia } from '@modules/knowledge/models/article/article-media';

@Injectable({providedIn: 'root'})
export class ArticleBlockAdapter implements Adapter<ArticleBlock> {
  constructor(){}

  adapt(item: any, pos:number = 0): ArticleBlock {
      const adaptedItem = {
        type: item.type as 'text' | 'gallery' | 'checklist' | 'video',
        id: `block-${pos}`,
        name: item.title,
        description: item.text,
        position: pos,
        imageAlign: item.imageAlignment || item.alignment,
        imageColumnCount: item.columns || 1,
        images: [] as ArticleMedia[],
        videoUrl: item.videoUrl ?? '',

        checklist: (item.items || []).map((item: string, key: number) => {
          return {
            id: '',
            position: key,
            name: item,
          };
        }),
      };

      if (adaptedItem.type === 'text') {
        if (item.image) {
          adaptedItem.images.push({
            position: 0,
            image: item.image.fileObject.fileUrl+'?filter=thumb&width=600',
            name: item.imageCaption || null
          });
        }
      } else if (adaptedItem.type === 'gallery') {
        adaptedItem.images = item.images.map((img: any, key: number) => {
          return {
            position: key,
            image: img.image.fileObject.fileUrl+'?filter=thumb&width=600',
            name: img.caption,
          };
        });
      }

    return adaptedItem;
  }

}
